'use client'

import { useContext } from 'react'
import { AppBar, Box, Container, Toolbar } from '@mui/material'
import { AuthContext } from '@wolfdanepug/common-react'
import { AppContext } from '../../context/app/AppContext'
import AccountDropdown from './AccountDropdown'
import Logo from './Logo'

export interface HeaderProps {
	position?: 'fixed' | 'sticky' | 'static' | 'relative' | 'absolute'
	height?: number
	heightOnScroll?: number
	isMobile?: boolean
}

export default function Header({ position = 'fixed', height = 110, isMobile }: HeaderProps) {
	const { useAppState } = useContext(AppContext)
	const { useContextUser } = useContext(AuthContext)
	const user: any = useContextUser()
	const state: any = useAppState()

	return (
		<AppBar position={position} sx={styles.root}>
			<Container maxWidth={false} disableGutters>
				<Toolbar sx={{ ...styles.toolbar, height }}>
					<Logo width={130} sx={styles.logo} isMobile={isMobile} />
					<Box sx={{ flexGrow: 1 }} />
					{state.navigationVisible && user && <AccountDropdown />}
				</Toolbar>
			</Container>
		</AppBar>
	)
}

const styles = {
	root: {
		background: 'none',
		color: 'text.primary',
		boxShadow: 0
	},
	toolbar: {
		transition: 'height 0.3s'
	},
	logo: {
		root: {
			zIndex: 1102
		},
		imageWrap: {
			top: 24
		}
	}
}
